import React from "react";
import {css, Theme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getOfferTypeNamePlural} from "../../../../offer/helpers/OfferType";
import {OfferType} from "../../../../offer/types/OfferType";

interface ISoldOffer {
    id: number;
    name: string;
    region: {
        short_name: string;
    };
    slug: string;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    groups: IOfferGroupsSimplified | null;
}

export interface VendorDetailSoldOfferBoxProps {
    offer: ISoldOffer;
    vendorSlug: string;
}

export const VendorDetailSoldOfferBox: React.FC<VendorDetailSoldOfferBoxProps> = ({offer, vendorSlug}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerAddress = `${offer.region.short_name}, ${offer.street_name && `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`}`;

    return (
        <a href={offerLink} css={soldOffersListItem} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodySimple css={cardBodyStyle}>
                    <div css={infoTextHolder}>
                        <Text as="h3" variant="headline_5" css={[mb(1)]}>
                            {offer.name}{" "}
                            <Text as="span" variant="info_txt_1" css={noWrap}>
                                ({getOfferTypeNamePlural(offer.type)})
                            </Text>
                        </Text>
                        <Text as="p" variant="body_copy_2" css={[mb(2)]}>
                            {offerAddress}
                        </Text>
                    </div>
                    <div css={badgeHolder}>
                        <Badge variant="label_secondary">Oferta archiwalna</Badge>
                    </div>
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </a>
    );
};

const cardBodyStyle = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
`;

const infoTextHolder = css`
    flex: 1 1 auto;
`;

const noWrap = css`
    white-space: nowrap;
`;

const badgeHolder = () => css`
    align-self: center;
    flex: 0 0;
`;

const soldOffersListItem = (theme: Theme) => css`
    &:hover {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getOfferTypeNamePlural} from "../../../../offer/helpers/OfferType";
import {OfferType} from "../../../../offer/types/OfferType";

interface ISoldOffer {
    id: number;
    name: string;
    region: {
        short_name: string;
    };
    slug: string;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    groups: IOfferGroupsSimplified | null;
}

export interface VendorDetailSoldOfferBoxProps {
    offer: ISoldOffer;
    vendorSlug: string;
}

export const VendorDetailSoldOfferBox: React.FC<VendorDetailSoldOfferBoxProps> = ({offer, vendorSlug}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerAddress = `${offer.region.short_name}, ${offer.street_name && `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`}`;

    return (
        <a href={offerLink} css={soldOffersListItem} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodySimple css={cardBodyStyle}>
                    <div css={infoTextHolder}>
                        <Text as="h3" variant="headline_5" css={[mb(1)]}>
                            {offer.name}{" "}
                            <Text as="span" variant="info_txt_1" css={noWrap}>
                                ({getOfferTypeNamePlural(offer.type)})
                            </Text>
                        </Text>
                        <Text as="p" variant="body_copy_2" css={[mb(2)]}>
                            {offerAddress}
                        </Text>
                    </div>
                    <div css={badgeHolder}>
                        <Badge variant="label_secondary">Oferta archiwalna</Badge>
                    </div>
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </a>
    );
};

const cardBodyStyle = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
`;

const infoTextHolder = css`
    flex: 1 1 auto;
`;

const noWrap = css`
    white-space: nowrap;
`;

const badgeHolder = () => css`
    align-self: center;
    flex: 0 0;
`;

const soldOffersListItem = (theme: Theme) => css`
    &:hover {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;
